import { useMemo } from "react";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
const useProductHasCampaign = (product, categories) => {
    const { productHasCampaign } = usePriceList();
    return useMemo(() => {
        if (!product) {
            return false;
        }
        for (const category of categories) {
            if (productHasCampaign(product, category)) {
                return true;
            }
        }
        return false;
    }, [product, categories, productHasCampaign]);
};
export default useProductHasCampaign;
